/**
 * belfastpilates-production.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/BookBean', 'model/BuildingBean', 'model/RoomBean', 'model/UserBean'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./BookBean'), require('./BuildingBean'), require('./RoomBean'), require('./UserBean'));
  } else {
    // Browser globals (root is window)
    if (!root.BelfastpilatesProductionappspotcom) {
      root.BelfastpilatesProductionappspotcom = {};
    }
    root.BelfastpilatesProductionappspotcom.BookBean = factory(root.BelfastpilatesProductionappspotcom.ApiClient, root.BelfastpilatesProductionappspotcom.BookBean, root.BelfastpilatesProductionappspotcom.BuildingBean, root.BelfastpilatesProductionappspotcom.RoomBean, root.BelfastpilatesProductionappspotcom.UserBean);
  }
}(this, function(ApiClient, BookBean, BuildingBean, RoomBean, UserBean) {
  'use strict';




  /**
   * The BookBean model module.
   * @module model/BookBean
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>BookBean</code>.
   * @alias module:model/BookBean
   * @class
   */
  var exports = function() {
    var _this = this;
































































  };

  /**
   * Constructs a <code>BookBean</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/BookBean} obj Optional instance to populate.
   * @return {module:model/BookBean} The populated <code>BookBean</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('allDay')) {
        obj['allDay'] = ApiClient.convertToType(data['allDay'], 'Boolean');
      }
      if (data.hasOwnProperty('available')) {
        obj['available'] = ApiClient.convertToType(data['available'], 'Boolean');
      }
      if (data.hasOwnProperty('bookedBookList')) {
        obj['bookedBookList'] = ApiClient.convertToType(data['bookedBookList'], [BookBean]);
      }
      if (data.hasOwnProperty('bookedServiceName')) {
        obj['bookedServiceName'] = ApiClient.convertToType(data['bookedServiceName'], 'String');
      }
      if (data.hasOwnProperty('bookedUserDetails')) {
        obj['bookedUserDetails'] = ApiClient.convertToType(data['bookedUserDetails'], [UserBean]);
      }
      if (data.hasOwnProperty('bookedUserEmail')) {
        obj['bookedUserEmail'] = ApiClient.convertToType(data['bookedUserEmail'], 'String');
      }
      if (data.hasOwnProperty('bookedUserFirstName')) {
        obj['bookedUserFirstName'] = ApiClient.convertToType(data['bookedUserFirstName'], 'String');
      }
      if (data.hasOwnProperty('bookedUserSurname')) {
        obj['bookedUserSurname'] = ApiClient.convertToType(data['bookedUserSurname'], 'String');
      }
      if (data.hasOwnProperty('bookedUserTelephone')) {
        obj['bookedUserTelephone'] = ApiClient.convertToType(data['bookedUserTelephone'], 'String');
      }
      if (data.hasOwnProperty('buildingBean')) {
        obj['buildingBean'] = BuildingBean.constructFromObject(data['buildingBean']);
      }
      if (data.hasOwnProperty('codeTag')) {
        obj['codeTag'] = ApiClient.convertToType(data['codeTag'], 'String');
      }
      if (data.hasOwnProperty('count')) {
        obj['count'] = ApiClient.convertToType(data['count'], 'Number');
      }
      if (data.hasOwnProperty('countryCode')) {
        obj['countryCode'] = ApiClient.convertToType(data['countryCode'], 'String');
      }
      if (data.hasOwnProperty('currencyCode')) {
        obj['currencyCode'] = ApiClient.convertToType(data['currencyCode'], 'String');
      }
      if (data.hasOwnProperty('currencyDecimalPlaces')) {
        obj['currencyDecimalPlaces'] = ApiClient.convertToType(data['currencyDecimalPlaces'], 'String');
      }
      if (data.hasOwnProperty('currencySymbol')) {
        obj['currencySymbol'] = ApiClient.convertToType(data['currencySymbol'], 'String');
      }
      if (data.hasOwnProperty('date')) {
        obj['date'] = ApiClient.convertToType(data['date'], 'Date');
      }
      if (data.hasOwnProperty('dateCreated')) {
        obj['dateCreated'] = ApiClient.convertToType(data['dateCreated'], 'Date');
      }
      if (data.hasOwnProperty('dateToDisplay')) {
        obj['dateToDisplay'] = ApiClient.convertToType(data['dateToDisplay'], 'String');
      }
      if (data.hasOwnProperty('day')) {
        obj['day'] = ApiClient.convertToType(data['day'], 'String');
      }
      if (data.hasOwnProperty('dayInt')) {
        obj['dayInt'] = ApiClient.convertToType(data['dayInt'], 'Number');
      }
      if (data.hasOwnProperty('dayOfWeek')) {
        obj['dayOfWeek'] = ApiClient.convertToType(data['dayOfWeek'], 'String');
      }
      if (data.hasOwnProperty('description')) {
        obj['description'] = ApiClient.convertToType(data['description'], 'String');
      }
      if (data.hasOwnProperty('duration')) {
        obj['duration'] = ApiClient.convertToType(data['duration'], 'String');
      }
      if (data.hasOwnProperty('employeeUserId')) {
        obj['employeeUserId'] = ApiClient.convertToType(data['employeeUserId'], 'String');
      }
      if (data.hasOwnProperty('endTime')) {
        obj['endTime'] = ApiClient.convertToType(data['endTime'], 'String');
      }
      if (data.hasOwnProperty('endTimeHour')) {
        obj['endTimeHour'] = ApiClient.convertToType(data['endTimeHour'], 'String');
      }
      if (data.hasOwnProperty('endTimeMinute')) {
        obj['endTimeMinute'] = ApiClient.convertToType(data['endTimeMinute'], 'String');
      }
      if (data.hasOwnProperty('fullRefund')) {
        obj['fullRefund'] = ApiClient.convertToType(data['fullRefund'], 'String');
      }
      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('idempotencyKey')) {
        obj['idempotencyKey'] = ApiClient.convertToType(data['idempotencyKey'], 'String');
      }
      if (data.hasOwnProperty('identifier')) {
        obj['identifier'] = ApiClient.convertToType(data['identifier'], 'String');
      }
      if (data.hasOwnProperty('instructorDetails')) {
        obj['instructorDetails'] = ApiClient.convertToType(data['instructorDetails'], [UserBean]);
      }
      if (data.hasOwnProperty('instructorIds')) {
        obj['instructorIds'] = ApiClient.convertToType(data['instructorIds'], ['String']);
      }
      if (data.hasOwnProperty('lastUpdatedDateTime')) {
        obj['lastUpdatedDateTime'] = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      }
      if (data.hasOwnProperty('level')) {
        obj['level'] = ApiClient.convertToType(data['level'], 'String');
      }
      if (data.hasOwnProperty('message')) {
        obj['message'] = ApiClient.convertToType(data['message'], 'String');
      }
      if (data.hasOwnProperty('month')) {
        obj['month'] = ApiClient.convertToType(data['month'], 'String');
      }
      if (data.hasOwnProperty('monthInt')) {
        obj['monthInt'] = ApiClient.convertToType(data['monthInt'], 'Number');
      }
      if (data.hasOwnProperty('originalBookRef')) {
        obj['originalBookRef'] = ApiClient.convertToType(data['originalBookRef'], 'String');
      }
      if (data.hasOwnProperty('paid')) {
        obj['paid'] = ApiClient.convertToType(data['paid'], 'Boolean');
      }
      if (data.hasOwnProperty('paymentId')) {
        obj['paymentId'] = ApiClient.convertToType(data['paymentId'], 'String');
      }
      if (data.hasOwnProperty('paymentMethod')) {
        obj['paymentMethod'] = ApiClient.convertToType(data['paymentMethod'], 'String');
      }
      if (data.hasOwnProperty('paymentReference')) {
        obj['paymentReference'] = ApiClient.convertToType(data['paymentReference'], 'String');
      }
      if (data.hasOwnProperty('price')) {
        obj['price'] = ApiClient.convertToType(data['price'], 'String');
      }
      if (data.hasOwnProperty('priceToDisplay')) {
        obj['priceToDisplay'] = ApiClient.convertToType(data['priceToDisplay'], 'String');
      }
      if (data.hasOwnProperty('refunded')) {
        obj['refunded'] = ApiClient.convertToType(data['refunded'], 'Boolean');
      }
      if (data.hasOwnProperty('roomBean')) {
        obj['roomBean'] = RoomBean.constructFromObject(data['roomBean']);
      }
      if (data.hasOwnProperty('roomId')) {
        obj['roomId'] = ApiClient.convertToType(data['roomId'], 'String');
      }
      if (data.hasOwnProperty('schedulerId')) {
        obj['schedulerId'] = ApiClient.convertToType(data['schedulerId'], 'String');
      }
      if (data.hasOwnProperty('searchId')) {
        obj['searchId'] = ApiClient.convertToType(data['searchId'], 'String');
      }
      if (data.hasOwnProperty('serviceId')) {
        obj['serviceId'] = ApiClient.convertToType(data['serviceId'], 'String');
      }
      if (data.hasOwnProperty('setId')) {
        obj['setId'] = ApiClient.convertToType(data['setId'], 'String');
      }
      if (data.hasOwnProperty('startTime')) {
        obj['startTime'] = ApiClient.convertToType(data['startTime'], 'String');
      }
      if (data.hasOwnProperty('startTimeHour')) {
        obj['startTimeHour'] = ApiClient.convertToType(data['startTimeHour'], 'String');
      }
      if (data.hasOwnProperty('startTimeMinute')) {
        obj['startTimeMinute'] = ApiClient.convertToType(data['startTimeMinute'], 'String');
      }
      if (data.hasOwnProperty('swapId')) {
        obj['swapId'] = ApiClient.convertToType(data['swapId'], 'String');
      }
      if (data.hasOwnProperty('type')) {
        obj['type'] = ApiClient.convertToType(data['type'], 'String');
      }
      if (data.hasOwnProperty('userId')) {
        obj['userId'] = ApiClient.convertToType(data['userId'], 'String');
      }
      if (data.hasOwnProperty('voucherDiscount')) {
        obj['voucherDiscount'] = ApiClient.convertToType(data['voucherDiscount'], 'String');
      }
      if (data.hasOwnProperty('voucherName')) {
        obj['voucherName'] = ApiClient.convertToType(data['voucherName'], 'String');
      }
      if (data.hasOwnProperty('year')) {
        obj['year'] = ApiClient.convertToType(data['year'], 'String');
      }
      if (data.hasOwnProperty('yearInt')) {
        obj['yearInt'] = ApiClient.convertToType(data['yearInt'], 'Number');
      }
    }
    return obj;
  }

  /**
   * @member {Boolean} allDay
   */
  exports.prototype['allDay'] = undefined;
  /**
   * @member {Boolean} available
   */
  exports.prototype['available'] = undefined;
  /**
   * @member {Array.<module:model/BookBean>} bookedBookList
   */
  exports.prototype['bookedBookList'] = undefined;
  /**
   * @member {String} bookedServiceName
   */
  exports.prototype['bookedServiceName'] = undefined;
  /**
   * @member {Array.<module:model/UserBean>} bookedUserDetails
   */
  exports.prototype['bookedUserDetails'] = undefined;
  /**
   * @member {String} bookedUserEmail
   */
  exports.prototype['bookedUserEmail'] = undefined;
  /**
   * @member {String} bookedUserFirstName
   */
  exports.prototype['bookedUserFirstName'] = undefined;
  /**
   * @member {String} bookedUserSurname
   */
  exports.prototype['bookedUserSurname'] = undefined;
  /**
   * @member {String} bookedUserTelephone
   */
  exports.prototype['bookedUserTelephone'] = undefined;
  /**
   * @member {module:model/BuildingBean} buildingBean
   */
  exports.prototype['buildingBean'] = undefined;
  /**
   * @member {String} codeTag
   */
  exports.prototype['codeTag'] = undefined;
  /**
   * @member {Number} count
   */
  exports.prototype['count'] = undefined;
  /**
   * @member {String} countryCode
   */
  exports.prototype['countryCode'] = undefined;
  /**
   * @member {String} currencyCode
   */
  exports.prototype['currencyCode'] = undefined;
  /**
   * @member {String} currencyDecimalPlaces
   */
  exports.prototype['currencyDecimalPlaces'] = undefined;
  /**
   * @member {String} currencySymbol
   */
  exports.prototype['currencySymbol'] = undefined;
  /**
   * @member {Date} date
   */
  exports.prototype['date'] = undefined;
  /**
   * @member {Date} dateCreated
   */
  exports.prototype['dateCreated'] = undefined;
  /**
   * @member {String} dateToDisplay
   */
  exports.prototype['dateToDisplay'] = undefined;
  /**
   * @member {String} day
   */
  exports.prototype['day'] = undefined;
  /**
   * @member {Number} dayInt
   */
  exports.prototype['dayInt'] = undefined;
  /**
   * @member {String} dayOfWeek
   */
  exports.prototype['dayOfWeek'] = undefined;
  /**
   * @member {String} description
   */
  exports.prototype['description'] = undefined;
  /**
   * @member {String} duration
   */
  exports.prototype['duration'] = undefined;
  /**
   * @member {String} employeeUserId
   */
  exports.prototype['employeeUserId'] = undefined;
  /**
   * @member {String} endTime
   */
  exports.prototype['endTime'] = undefined;
  /**
   * @member {String} endTimeHour
   */
  exports.prototype['endTimeHour'] = undefined;
  /**
   * @member {String} endTimeMinute
   */
  exports.prototype['endTimeMinute'] = undefined;
  /**
   * @member {String} fullRefund
   */
  exports.prototype['fullRefund'] = undefined;
  /**
   * @member {String} id
   */
  exports.prototype['id'] = undefined;
  /**
   * @member {String} idempotencyKey
   */
  exports.prototype['idempotencyKey'] = undefined;
  /**
   * @member {String} identifier
   */
  exports.prototype['identifier'] = undefined;
  /**
   * @member {Array.<module:model/UserBean>} instructorDetails
   */
  exports.prototype['instructorDetails'] = undefined;
  /**
   * @member {Array.<String>} instructorIds
   */
  exports.prototype['instructorIds'] = undefined;
  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype['lastUpdatedDateTime'] = undefined;
  /**
   * @member {String} level
   */
  exports.prototype['level'] = undefined;
  /**
   * @member {String} message
   */
  exports.prototype['message'] = undefined;
  /**
   * @member {String} month
   */
  exports.prototype['month'] = undefined;
  /**
   * @member {Number} monthInt
   */
  exports.prototype['monthInt'] = undefined;
  /**
   * @member {String} originalBookRef
   */
  exports.prototype['originalBookRef'] = undefined;
  /**
   * @member {Boolean} paid
   */
  exports.prototype['paid'] = undefined;
  /**
   * @member {String} paymentId
   */
  exports.prototype['paymentId'] = undefined;
  /**
   * @member {String} paymentMethod
   */
  exports.prototype['paymentMethod'] = undefined;
  /**
   * @member {String} paymentReference
   */
  exports.prototype['paymentReference'] = undefined;
  /**
   * @member {String} price
   */
  exports.prototype['price'] = undefined;
  /**
   * @member {String} priceToDisplay
   */
  exports.prototype['priceToDisplay'] = undefined;
  /**
   * @member {Boolean} refunded
   */
  exports.prototype['refunded'] = undefined;
  /**
   * @member {module:model/RoomBean} roomBean
   */
  exports.prototype['roomBean'] = undefined;
  /**
   * @member {String} roomId
   */
  exports.prototype['roomId'] = undefined;
  /**
   * @member {String} schedulerId
   */
  exports.prototype['schedulerId'] = undefined;
  /**
   * @member {String} searchId
   */
  exports.prototype['searchId'] = undefined;
  /**
   * @member {String} serviceId
   */
  exports.prototype['serviceId'] = undefined;
  /**
   * @member {String} setId
   */
  exports.prototype['setId'] = undefined;
  /**
   * @member {String} startTime
   */
  exports.prototype['startTime'] = undefined;
  /**
   * @member {String} startTimeHour
   */
  exports.prototype['startTimeHour'] = undefined;
  /**
   * @member {String} startTimeMinute
   */
  exports.prototype['startTimeMinute'] = undefined;
  /**
   * @member {String} swapId
   */
  exports.prototype['swapId'] = undefined;
  /**
   * @member {String} type
   */
  exports.prototype['type'] = undefined;
  /**
   * @member {String} userId
   */
  exports.prototype['userId'] = undefined;
  /**
   * @member {String} voucherDiscount
   */
  exports.prototype['voucherDiscount'] = undefined;
  /**
   * @member {String} voucherName
   */
  exports.prototype['voucherName'] = undefined;
  /**
   * @member {String} year
   */
  exports.prototype['year'] = undefined;
  /**
   * @member {Number} yearInt
   */
  exports.prototype['yearInt'] = undefined;



  return exports;
}));





// WEBPACK FOOTER //
// ./clientLibsProduction/src/model/BookBean.js